module.exports = __webpack_public_path__ + "static/desk.c30309a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/desk.jpg
// module id = 341
// module chunks = 35783957827783